import { api, apiMipe } from '@/core/api/';
const URL = 'api/umesr';

export const getUmesrAcademicYears = () =>
  apiMipe.get('api/academicyears/umesr');

export const getUmesrFilters = async () => await api.get(`${URL}/initfilters`);

export const getSearch = async (request) =>
  await api.get(`${URL}/search`, {
    params: {
      ...request,
    },
  });

export const getUmesrFindings = (params) =>
  api.get(`${URL}/findings`, { params });

export const getUmesrFindingsById = (id) =>
  api.get(`${URL}/finding`, {
    params: {
      studentServiceMonitoringId: id,
    },
  });

export const removeUmesrFindingsById = (id) =>
  api.delete(`${URL}/finding/${id}`);

export const createUmesrFindings = (data) =>
  api.post(`${URL}/finding`, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const updateUmesrFindings = (id, data) =>
  api.put(`${URL}/finding`, {
    ...data,
    id,
  });

export const getDocumentTypes = () =>
  apiMipe.get(`api/documents/documenttypes`, {
    params: {
      codetype: 'TherapyStudentServiceMonitoringDocument',
    },
  });

export const createUmesrFindingsDocuments = (
  studentServiceMonitoringId,
  data
) => api.post(`${URL}/finding/document/${studentServiceMonitoringId}`, data);

export const deleteUmesrFindingsDocuments = (id) =>
  api.delete(`${URL}/finding/document/${id}`);

export const getCodeExemptionFindingType = async () =>
  apiMipe.get(`/api/code/billingadjustmentreasons`, {
    params: {
      isValidForUMESR: true,
    },
  });
